import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { yupErrorMsg } from '../../../../components/atoms/const';
import api from '../../../../components/api';

interface InitValuesData {
  'id': number;
  'serviceStatus': number | null;
  'statusUpdated': number | null;
  'invoiceId': number | null;
  'scheduleDate': Date | null; // "01/15/2022 10:00:00",
  'requestDate': Date | null; // "01/15/2022 10:00:00",
  serviceReason: number | null,
  priority: number | null,
  clientName: string | null,
  vmId: number | null,
  userId: number | null,
  comment: string;
  firstname: string;
  lastname: string;
  phoneNumber: string;
  email: string;
  removed: boolean;
}

function useEditService() {
  const { ticketId } = useParams();
  const [invoices, setInvoices] = useState([]);
  const navigate = useNavigate();
  const navigateToLanding = () => navigate('/customer-support/services');
  const navigateToInvoices = () => navigate(`/customer-support/add-invoice/${ticketId}`);
  const navigateToViewInvoice = () => navigate('/customer-support/invoice');

  const { mutate: updateServiceRequest, isLoading: updateServiceLoad } = useMutation(api.customerSupport.updateServiceRequest, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      alert('success');
      navigateToLanding();
    },
    onError: (error) => {
      console.log(error);
      alert('error');
    },
  });

  const { data, isLoading } = useQuery(
    ['getServiceById', 'customerSupport'],
    () => api.customerSupport.getServiceById(ticketId),
  );

  const { data: technicianList } = useQuery(
    ['getAllByType', 'customerSupport'],
    () => api.customerSupport.getAllByType(),
  );

  const driverList = () => technicianList?.data?.data?.map((x: any) => {
    const { firstname, lastname, id: idDriver } = x;
    return {
      value: idDriver,
      label: `${firstname ?? ''} ${lastname ?? ''}`,
    };
  });

  const getInvoiceData = async (name: string) => {
    const invoiceData: any = await api.customerSupport.getInvoicesByName(name);
    setInvoices(invoiceData?.data?.data ?? []);
  };

  const getInvoiceDataByService = async (serviceId: string) => {
    console.log(serviceId);
    const invoiceData: any = await api.customerSupport.getInvoicesByServiceId(serviceId);
    setInvoices(invoiceData?.data?.data ?? []);
  };

  const serviceData: any = React.useMemo(() => {
    const listData: any = data?.data.data;
    if (listData) {
      // getInvoiceData(listData?.clientName);
      getInvoiceDataByService(ticketId!);
      return listData;
    }
    return undefined;
  }, [data]);

  const yupSchema = yup.object({
    // serviceStatus: yup.object().nullable().required(yupErrorMsg.SERVICE_STATUS_EMPTY),
    // priority: yup.object().nullable().required(yupErrorMsg.PRIORITY_EMPTY),
  });

  const initValues: InitValuesData = {
    id: Number(ticketId),
    serviceReason: null,
    clientName: null,
    vmId: null,
    comment: '',
    firstname: '',
    priority: null,
    lastname: '',
    phoneNumber: '',
    email: '',
    scheduleDate: null,
    removed: false,
    statusUpdated: null,
    serviceStatus: 0,
    requestDate: null,
    invoiceId: null,
    userId: null,
  };

  const getDateFormat = (date: Date) => `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} 00:00:00`;

  const formik = useFormik({
    initialValues: initValues,
    // validationSchema: yupSchema,
    onSubmit: (values) => {
      updateServiceRequest({
        id: values.id,
        serviceStatus: values.serviceStatus ?? null,
        priority: values.priority ?? null,
        scheduleDate: values.scheduleDate ? getDateFormat(new Date(values.scheduleDate)) : null,
        comment: values.comment ?? null,
        userId: values.userId ?? null,
      });
    },
  });

  // Initial data when on Edit Mode
  React.useEffect(() => {
    if (data?.data?.data) {
      formik.setFieldValue('id', serviceData?.id ?? '');
      formik.setFieldValue('clientName', serviceData?.clientName ?? '');
      formik.setFieldValue('vmId', serviceData?.vmId ?? '');
      formik.setFieldValue('serviceReason', serviceData?.serviceReason ?? '');
      formik.setFieldValue('serviceStatus', serviceData?.serviceStatus ?? '');
      formik.setFieldValue('priority', serviceData?.priority ?? '');
      formik.setFieldValue('requestDate', serviceData?.requestDate ?? '');
      formik.setFieldValue('email', serviceData?.clientName ?? '');
      formik.setFieldValue('scheduleDate', serviceData?.scheduleDate ?? '');
      formik.setFieldValue('userId', serviceData?.user?.id ?? '');
    }
  }, [data]);

  return {
    ticketId,
    formik,
    invoices,
    navigateToInvoices,
    navigateToViewInvoice,
    navigateToLanding,
    updateServiceLoad,
    driverList,
  };
}

export default useEditService;
